import { useState } from "react";
import { CheckCheck, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";

const when = (iso) => (iso ? new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");

export function SeenBy({ m }) {
  const [rows, setRows] = useState(null);
  const r = m.receipt || { seen: 0, total: 0 };
  const load = (open) => { if (open) { api.get(`/messages/broadcast/${m.broadcast_id}`).then((x) => setRows(x.data)).catch(() => setRows([])); } };
  return (
    <Popover onOpenChange={load}>
      <PopoverTrigger asChild>
        <button className="inline-flex items-center gap-1 underline-offset-2 hover:underline" data-testid={`msg-seen-by-${m.id}`}>
          <CheckCheck className="h-3.5 w-3.5" /> Seen by {r.seen} of {r.total}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" collisionPadding={12} className="max-h-72 w-80 max-w-[calc(100vw-24px)] overflow-y-auto p-0" data-testid="seen-by-list">
        {!rows && <p className="p-4 text-sm text-slate-500">Loading...</p>}
        {rows?.map((x) => (
          <div key={x.user_id} className="flex items-start gap-2 border-b border-slate-100 px-4 py-2 text-sm" data-testid={`seen-row-${x.user_id}`}>
            {x.seen ? <CheckCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /> : <Check className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" />}
            <div className="min-w-0">
              <div className="truncate font-semibold text-slate-800">{x.name}</div>
              <div className="truncate text-xs text-slate-500">{x.church_name}</div>
              <div className="text-xs text-slate-500">{x.seen ? `Seen ${when(x.seen_at)}` : "Not seen yet"}</div>
            </div>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}

export function Receipt({ m, adminView }) {
  if (adminView && m.broadcast_id) return <SeenBy m={m} />;
  const seen = adminView ? m.read_by_user : m.read_by_admin;
  const at = adminView ? m.user_read_at : m.admin_read_at;
  return (
    <span className="inline-flex items-center gap-1" data-testid={`msg-receipt-${m.id}`}>
      {seen ? <CheckCheck className="h-3.5 w-3.5" /> : <Check className="h-3.5 w-3.5" />}
      {seen ? `${adminView ? "Seen" : "Seen by admin"}${at ? ` · ${when(at)}` : ""}` : "Sent"}
    </span>
  );
}
